import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AjaxService } from './ajax.service';
import { TWO_FACTOR_STATUS, TWO_FACTOR_SETUP, TWO_FACTOR_CONFIRM, TWO_FACTOR_DISABLE } from './account-api.constants';

export interface TwoFactorStatus {
	Enabled: boolean;
}

export interface TwoFactorSetupResult {
	OtpUri: string;
	Secret: string;
}

@Injectable({
	providedIn: 'root'
})
export class TwoFactorService {
	private httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

	constructor(private http: HttpClient, private ajaxService: AjaxService) { }

	getStatus(userRecId: number): Observable<TwoFactorStatus> {
		const url = this.ajaxService.getBaseOfApi() + TWO_FACTOR_STATUS + '?userid=' + userRecId;
		return this.http.get<TwoFactorStatus>(url);
	}

	setup(userRecId: number, accountLabel?: string): Observable<TwoFactorSetupResult> {
		const url = this.ajaxService.getBaseOfApi() + TWO_FACTOR_SETUP;
		return this.http.post<TwoFactorSetupResult>(url, { UserRecID: userRecId, AccountLabel: accountLabel }, this.httpOptions);
	}

	confirm(userRecId: number, code: string): Observable<any> {
		const url = this.ajaxService.getBaseOfApi() + TWO_FACTOR_CONFIRM;
		return this.http.post(url, { UserRecID: userRecId, Code: code }, this.httpOptions);
	}

	disable(userRecId: number): Observable<any> {
		const url = this.ajaxService.getBaseOfApi() + TWO_FACTOR_DISABLE;
		return this.http.post(url, { UserRecID: userRecId }, this.httpOptions);
	}
}
